import { styled } from 'styled-components';
import { textSmallSemiBold } from '@hud/web-components/DesignSystem/Typography';

export default styled.div`
  position: relative;
  display: flex;
  transition: all 0.2s ease-out;
  padding: var(--space-150);
  background: var(--black-200);
  border-radius: var(--radius-400);
  z-index: 1;

  .icon {
    width: 35px;
    height: 35px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--border-color-default);
    border-radius: var(--radius-full);
    background-color: var(--black-100);
    color: var(--black-900);
  }

  .content {
    margin-left: var(--space-200);
    display: flex;
    flex-direction: column;
    gap: var(--space-300);
  }

  p {
    ${textSmallSemiBold};
    color: var(--text-subtle);
    margin: 0;
  }

  a {
    display: flex;
    align-items: center;
    gap: var(--space-50);
  }


  &:hover {
    background: var(--black-400);
    &:before {
      opacity: 1;
    }
  }
`
